import { ref } from '@vue/composition-api';
import { commonModuleConfig, ModuleConfig, SORT_WEIGHT } from '@/config/module-config';

type SortParams = Pick<ModuleConfig, 'sort'>;

/**
 * 已排序好的模块
 */
const sortedModuleConfig = ref<ModuleConfig[]>([]);

/** 計算模塊排序值 */
const getModuleSort = ({ sort }: SortParams) => {
  const finalSort = (sort || 0) * SORT_WEIGHT;
  return finalSort;
};

/**
 * 模块排序
 */
function sortMoudleConfig() {
  return commonModuleConfig.sort((a: SortParams, b: SortParams) => (getModuleSort(a) < getModuleSort(b) ? 1 : -1));
}

sortedModuleConfig.value = sortMoudleConfig();

export function useModuleConfig() {
  return {
    sortedModuleConfig,
  };
}
